/* Graced – small storefront behaviours for Dawn (carousels, sticky add to cart) */
(function () {
  'use strict';

  /* ---------- Carousel with prev/next arrows ---------- */
  if (!customElements.get('g-carousel')) {
    customElements.define(
      'g-carousel',
      class GCarousel extends HTMLElement {
        connectedCallback() {
          this.track = this.querySelector('[data-track]');
          this.prev = this.querySelector('[data-prev]');
          this.next = this.querySelector('[data-next]');
          if (!this.track) return;
          this.update = this.update.bind(this);
          if (this.prev) this.prev.addEventListener('click', () => this.step(-1));
          if (this.next) this.next.addEventListener('click', () => this.step(1));
          this.track.addEventListener('scroll', () => window.requestAnimationFrame(this.update), { passive: true });
          window.addEventListener('resize', this.update);
          this.update();
          window.setTimeout(this.update, 400);
        }
        step(dir) {
          const slide = this.track.firstElementChild;
          if (!slide) return;
          const gap = parseFloat(window.getComputedStyle(this.track).columnGap) || 0;
          const width = slide.getBoundingClientRect().width + gap;
          const perPage = Math.max(1, Math.round((this.track.clientWidth + gap) / width));
          this.track.scrollBy({ left: dir * perPage * width, behavior: 'smooth' });
        }
        update() {
          if (!this.track) return;
          const max = this.track.scrollWidth - this.track.clientWidth;
          this.classList.toggle('is-static', max <= 2);
          if (this.prev) this.prev.disabled = this.track.scrollLeft <= 2;
          if (this.next) this.next.disabled = this.track.scrollLeft >= max - 2;
        }
      }
    );
  }

  /* ---------- Sticky add to cart ---------- */
  if (!customElements.get('g-sticky-atc')) {
    customElements.define(
      'g-sticky-atc',
      class GStickyAtc extends HTMLElement {
        connectedCallback() {
          try {
            this.variants = JSON.parse(this.querySelector('[data-sticky-variants]').textContent);
          } catch (e) {
            this.variants = [];
          }
          this.btn = this.querySelector('[data-sticky-add]');
          this.btnLabel = this.querySelector('[data-sticky-label]');
          this.variantEl = this.querySelector('[data-sticky-variant]');
          this.priceEl = this.querySelector('[data-sticky-price]');
          this.onScroll = this.onScroll.bind(this);
          this.sync = this.sync.bind(this);

          if (this.btn) {
            this.btn.addEventListener('click', () => {
              const main = this.mainButton();
              if (main && !main.disabled && main.getAttribute('aria-disabled') !== 'true') {
                main.click();
              } else if (!main) {
                window.location.href = this.dataset.productUrl;
              }
            });
          }

          const change = this.querySelector('[data-sticky-change]');
          if (change) {
            change.addEventListener('click', (event) => {
              event.preventDefault();
              const picker = document.querySelector(
                '[id^="MainProduct-"] variant-selects, product-info variant-selects, variant-selects'
              );
              const target = picker || this.mainButton();
              if (target) target.scrollIntoView({ behavior: 'smooth', block: 'center' });
            });
          }

          window.addEventListener('scroll', this.onScroll, { passive: true });
          window.addEventListener('resize', this.onScroll);
          document.addEventListener('change', () => window.setTimeout(this.sync, 350));
          try {
            if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined' && PUB_SUB_EVENTS.variantChange) {
              subscribe(PUB_SUB_EVENTS.variantChange, () => window.setTimeout(this.sync, 50));
            }
          } catch (e) {
            /* variant sync falls back to the change listener */
          }
          this.sync();
          this.onScroll();
        }

        scope() {
          return document.querySelector('[id^="MainProduct-"]') || document.querySelector('product-info') || document;
        }

        mainButton() {
          return this.scope().querySelector('.product-form__submit, button[name="add"]');
        }

        onScroll() {
          if (this.ticking) return;
          this.ticking = true;
          window.requestAnimationFrame(() => {
            this.ticking = false;
            const main = this.mainButton();
            let show = false;
            if (main) {
              show = main.getBoundingClientRect().bottom < 0;
            } else {
              show = window.scrollY > 600;
            }
            this.classList.toggle('is-visible', show);
            document.body.classList.toggle('g-sticky-on', show);
          });
        }

        sync() {
          const scope = this.scope();
          const input = scope.querySelector('form[data-type="add-to-cart-form"] input[name="id"]') ||
            scope.querySelector('input[name="id"]');
          if (input) {
            const variant = this.variants.find((v) => String(v.id) === String(input.value));
            if (variant) {
              if (this.variantEl) this.variantEl.textContent = variant.title;
              if (this.priceEl) this.priceEl.textContent = variant.price;
            }
          }
          const main = this.mainButton();
          if (main && this.btn) {
            const disabled = main.disabled || main.getAttribute('aria-disabled') === 'true';
            this.btn.disabled = disabled;
            const span = main.querySelector('span');
            const text = span ? span.textContent.trim() : '';
            if (this.btnLabel && text) this.btnLabel.textContent = text;
          }
        }
      }
    );
  }

  /* ---------- Announcement bar: one message at a time ---------- */
  if (!customElements.get('g-announcements')) {
    customElements.define(
      'g-announcements',
      class GAnnouncements extends HTMLElement {
        connectedCallback() {
          if (this.dataset.style === 'ticker') return;
          this.slides = Array.from(this.querySelectorAll('[data-ann-slide]'));
          if (this.slides.length < 2) return;
          this.index = 0;
          this.delay = (parseInt(this.dataset.speed, 10) || 5) * 1000;
          const prev = this.querySelector('[data-ann-prev]');
          const next = this.querySelector('[data-ann-next]');
          if (prev) prev.addEventListener('click', () => { this.go(this.index - 1); this.restart(); });
          if (next) next.addEventListener('click', () => { this.go(this.index + 1); this.restart(); });
          this.addEventListener('mouseenter', () => this.stop());
          this.addEventListener('mouseleave', () => this.start());
          this.addEventListener('focusin', () => this.stop());
          this.addEventListener('focusout', () => this.start());
          document.addEventListener('shopify:block:select', (event) => {
            const i = this.slides.indexOf(event.target);
            if (i > -1) { this.stop(); this.go(i); }
          });
          document.addEventListener('shopify:block:deselect', () => this.start());
          this.start();
        }
        disconnectedCallback() {
          this.stop();
        }
        go(i) {
          const count = this.slides.length;
          const target = ((i % count) + count) % count;
          if (target === this.index) return;
          const current = this.slides[this.index];
          const incoming = this.slides[target];
          current.classList.remove('is-active');
          current.classList.add('is-leaving');
          current.setAttribute('aria-hidden', 'true');
          window.setTimeout(() => current.classList.remove('is-leaving'), 500);
          incoming.classList.add('is-active');
          incoming.removeAttribute('aria-hidden');
          this.index = target;
        }
        start() {
          this.stop();
          this.timer = window.setInterval(() => this.go(this.index + 1), this.delay);
        }
        stop() {
          if (this.timer) window.clearInterval(this.timer);
          this.timer = null;
        }
        restart() {
          this.start();
        }
      }
    );
  }

  /* ---------- Header and announcement heights ---------- */
  const root = document.documentElement;
  function setHeights() {
    const header = document.querySelector('.section-header');
    const ann = document.querySelector('.g-ann-section');
    if (header) root.style.setProperty('--g-header-h', header.offsetHeight + 'px');
    root.style.setProperty('--g-ann-h', (ann ? ann.offsetHeight : 0) + 'px');
  }
  setHeights();
  window.addEventListener('resize', setHeights);
  window.addEventListener('load', setHeights);
  document.addEventListener('DOMContentLoaded', setHeights);

  /* ---------- See-through header: turns solid once the visitor scrolls ---------- */
  const overlay = root.getAttribute('data-g-overlay');
  if (overlay) {
    const first = document.querySelector('#MainContent > .shopify-section:first-child');
    const fits = first && (overlay === 'product'
      ? first.querySelector('product-info .product__media-wrapper')
      : first.querySelector('.g-hero, .banner, slideshow-component'));
    if (!fits) {
      root.classList.remove('g-overlay');
      root.removeAttribute('data-g-overlay');
    } else {
      if (overlay === 'product') {
        /* Product pages: only on phones, where the photo sits right under the header */
        const phone = window.matchMedia('(max-width: 749px)');
        const apply = () => {
          root.classList.toggle('g-overlay', phone.matches);
          setHeights();
        };
        if (phone.addEventListener) phone.addEventListener('change', apply);
        else if (phone.addListener) phone.addListener(apply);
        apply();
      }
      const onScroll = () => root.classList.toggle('g-solid', window.scrollY > 10);
      window.addEventListener('scroll', onScroll, { passive: true });
      onScroll();
    }
  }
})();
